export const API_KEY = "AIzaSyCd0yXcaKKBsEaTtMvHJvVdWMk01sx5MxA";

export default API_KEY;
